var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-alert',{staticClass:"gl-mb-5",attrs:{"variant":"danger","dismissible":false}},[_c('gl-sprintf',{attrs:{"message":_vm.alertMessage},scopedSlots:_vm._u([{key:"link",fn:function({ content }){return [_c('gl-link',{attrs:{"href":_vm.currentPath,"target":"_blank","rel":"nofollow"}},[_vm._v("\n        "+_vm._s(content)+"\n      ")])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }